import { IconProps, sizeMap } from './IconProps';

function InfinityLogoIcon({
  fontSize = 'medium',
  className,
}: Readonly<IconProps>) {
  const size = sizeMap[fontSize];

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      aria-hidden="true"
      role="img"
      preserveAspectRatio="xMidYMid"
      className={className}
    >
      <circle fill="#3B94D9" cx="18" cy="18" r="18" />
      <path
        fill="#FFF"
        d="M25.565 11.295c-2.116 0-4.195 1.322-5.799 2.712a21.08 21.08 0 0 1 1.147 1.364c.172.227.423.534.733.882c1.236-1.084 2.689-2.044 3.919-2.044c2.09 0 3.79 1.7 3.79 3.79s-1.7 3.79-3.79 3.79c-2.337 0-5.484-3.456-6.402-4.668c-.45-.596-4.521-5.826-8.729-5.826c-3.697 0-6.705 3.008-6.705 6.705s3.008 6.704 6.705 6.704c2.055 0 4.073-1.248 5.657-2.594a21.026 21.026 0 0 1-1.255-1.483a14.747 14.747 0 0 0-.624-.757c-1.204 1.032-2.594 1.919-3.778 1.919c-2.09 0-3.79-1.7-3.79-3.79s1.7-3.79 3.79-3.79c2.338 0 5.484 3.456 6.402 4.668c.45.596 4.521 5.826 8.729 5.826a6.711 6.711 0 0 0 6.704-6.704a6.71 6.71 0 0 0-6.704-6.704z"
      />
    </svg>
  );
}

export default InfinityLogoIcon;
